import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ExpertQA from "@/pages/ExpertQA";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/expert-qa")({
  head: () => seoHead("/expert-qa"),
  component: () => (
    <AuthGate><ExpertQA /></AuthGate>
  ),
});
